module.exports = __webpack_public_path__ + "static/media/ripley-customer-care-responsibilities-chart.8c477f6a.jpeg";